#!/usr/bin/env node
import {parseArgs} from "@std/cli/parse-args";
import {import_meta_ponyfill} from "import-meta-ponyfill";
import {applyPageConfig, genPageConfig, readPageConfig} from "../google-aistudio/node/config-manager.js";

if (import_meta_ponyfill(import.meta).main) {
  const args = parseArgs(process.argv.slice(2), {
    string: ["session", "workDir"],
    alias: {
      s: "session",
      d: "workDir",
    },
  });

  const command = args._[0];
  const sessionId = args.session;
  const workDir = args.workDir || process.cwd();

  if (!sessionId) {
    console.error("Error: --session <sessionId> is required.");
    process.exit(1);
  }

  const options = {sessionId, workDir};

  switch (command) {
    case "read":
      await readPageConfig(options);
      break;
    case "apply":
      await applyPageConfig(options);
      break;
    case "gen":
      await genPageConfig(options);
      break;
    default:
      console.error(`Error: Unknown command "${command}". Available commands: read, apply, gen.`);
      process.exit(1);
  }
}
